import { render } from "./McpAppRenderer.vue?vue&type=template&id=86ef1f60&scoped=true"
import script from "./McpAppRenderer.vue?vue&type=script&lang=js"
export * from "./McpAppRenderer.vue?vue&type=script&lang=js"

import "./McpAppRenderer.vue?vue&type=style&index=0&id=86ef1f60&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ef1f60"]])

export default __exports__